import React, { ErrorInfo, ReactNode } from 'react'
import { Error } from '../../pages/Error'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

/**
 * Error Boundary per gli errori, mostra una pagina predefinita di errore
 */
export class ErrorBoundary extends React.Component<Props, State> {
  public state: State = {
    hasError: false,
  }

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      return <Error />
    }

    return this.props.children
  }
}
